export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-4.affdae8c.png";